export default __webpack_public_path__ + "static/media/regulatory--stop-signals--g1.9b8c0d01.png";